'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Swiper = require('./Swiper-89e148c7.js');
require('./_rollupPluginBabelHelpers-b2d9610a.js');
require('react');
require('./swiper-slide-bda38a10.js');
require('./a11y-6e397320.js');
require('./index-fccd5f88.js');
require('./injectGlobalCss-bc8cf911.js');
require('./Button-ef2d53dd.js');
require('./Icons-46f5553f.js');
require('./Loader-ba47a627.js');



exports.SwiperWrapper = Swiper.SwiperWrapper;
